import React from "react";
import RoleService from "../Services/roleService";

class FaIcon extends React.Component {
  static defaultProps = {
    className: 'icon',
    innerClassName: '',
    iconName: 'fa-solid fa-circle',
    onClick: null,
    tooltipText: '',
    disabled: false,
    roleKey: '',
    text: '',
    superScript: false,
  };

  render() {
    const enabled =
      !this.props.disabled &&
      (!this.props.roleKey || (this.props.roleKey && RoleService.CheckUserPermission('faicon', this.props.roleKey)));

    const cn =
      this.props.className === 'icon'
        ? this.props.onClick !== null && enabled
          ? 'icon iconlink'
          : 'icon'
        : this.props.className;

    const inner = (
      <span
        className={cn}
        onClick={enabled ? this.props.onClick : null}
        disabled={!enabled}
        data-tip={'tooltip'}
        data-placement='top'
        title={this.props.tooltipText}
      >
        <i
          className={`${this.props.iconName} ${this.props.innerClassName}${enabled ? '' : ' disabledicon '}`}
          disabled={!enabled}
        >
          {this.props.text && <span className='pl-2 icontext'>{this.props.text}</span>}
        </i>
      </span>
    );
    if (this.props.superScript) {
      return <sup className='superscript'>{inner}</sup>;
    }
    return inner;
  }
}

export default FaIcon;
